import { CustomContextPad } from './custom_context_pad'
import { CustomPopupMenu } from './custom_popup_menu'
import { CustomPalette } from './custom_palette'

export default {
  __init__: [
    'customPopupMenu',
    'customContextPad',
    'customPalette'
  ],
  customPopupMenu: ['type', CustomPopupMenu],
  customContextPad: ['type', CustomContextPad],
  customPalette: ['type', CustomPalette]
}
